import R from 'ramda'

const TIMESTAMP_DISPLAY_TYPE = 'Send at specific time'
const TIMESTAMP_TRIGGER_TYPE = 'TIMESTAMP'

const isTimestampWidgetTrigger = R.propEq('type', TIMESTAMP_TRIGGER_TYPE)

const getExpiration = R.pipe(
  R.converge(R.subtract, [R.prop('expiration'), R.prop('data')]),
  R.divide(R.__, 60000)
)

const convertTimestampWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(TIMESTAMP_DISPLAY_TYPE),
  data: R.prop('data'),
  expiration: getExpiration,
  executedAt: R.prop('executedAt')
})

export { isTimestampWidgetTrigger, convertTimestampWidgetTriggerToFormTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/common-triggers/widget-to-form/timestamp.js